import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { MessageService, notCloseMessageOptions } from '../../../../core';
import { DatepickerComponent } from '../../../../shared';
import { AtividadeRetorno } from '../atividade-retorno';
import { NgForm } from '@angular/forms';
import { AtividadeRef } from '../../ref';
import { AtividadeRetornoInsert } from '../atividade-retorno-insert';
import { Usuario } from '../../../usuario/usuario';

@Component({
    selector: 'sgt-atividade-retorno-form',
    templateUrl: './atividade-retorno-form.component.html',
    styleUrls: ['./atividade-retorno-form.component.less']
})
export class AtividadeRetornoFormComponent {
    @Input() entity: AtividadeRetorno;
    @Input() canEdit = true;
    @Output() openAtividade = new EventEmitter<AtividadeRef>();

    @ViewChild('form') form: NgForm;
    @ViewChild('diaRetornoDatepicker') diaRetornoDatepicker: DatepickerComponent;

    constructor(private messageService: MessageService) { }

    onChangeRetornar(value: boolean) {
        this.entity.retornar = value;

        // Se deve retornar a atividade e ainda não criado os dados do insert da atividade de retorno
        if (this.entity.retornar && !this.entity.atividadeRetornoInsert) {
            this.createRetornoInsert();
        }
    }

    /** Cria os dados para insert da atividade de retorno */
    private createRetornoInsert() {
        this.entity.atividadeRetornoInsert = new AtividadeRetornoInsert(this.entity.tipo, this.entity.idUsuarioDestino, this.entity.usuarioDestino);
    }

    /** Ao alterar o usuário de destino (responsável) */
    onChangeResponsavelRetorno(usuarioDestino: Usuario) {
        if (usuarioDestino) {
            this.entity.atividadeRetornoInsert.idUsuarioDestino = usuarioDestino.id;
        } else {
            this.entity.atividadeRetornoInsert.idUsuarioDestino = null;
        }
    }

    /** Verifica se o form de retorno da atividade está válido */
    isValid() {
        // Marcado para retornar mas não informado o dia do retorno
        if (this.entity.retornar && !this.entity.diaRetorno) {
            this.messageService.warning('Selecione o dia para retornar esta atividade', 'Atenção', notCloseMessageOptions);
            this.diaRetornoDatepicker.setFocus();
            return false;
        }

        // Form inválido
        if (this.form.invalid) {
            this.messageService.warning('Selecione corretamente todas as informações do retorno da atividade', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
